import Vue from "vue";
import VueTransmit from "vue-transmit";

export default () => {
  Vue.use(VueTransmit);
};
